import { styled } from '@mui/material/styles';
const P = styled('p')({});
export default P;
